<template>
	<div>
		<AmeliproFooter
			:version="version"
			no-a11y
			no-about
			no-configuration
			legal-notice-to="/legal-notice"
			no-link-a11y
			no-site-map
			cgu-to="/cgu"
		/>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	@Component({})
	export default class AppFooter extends Vue {
		version = process.env.VUE_APP_VERSION;
	}
</script>
